module.exports = __webpack_public_path__ + "static/media/5.5c530d46.jpg";